import Request from "./Request";

export { default as Error } from "./Error";

export const request = new Request();

export const Status = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
};

export const Destination = {
  RED: 1,
  TWITTER: 2,
  UNKNOWN: 3,
  ORGANIC: 4,
};

export const TrackingVendor = {
  ADJUST: 1,
  MAT: 2,
  APPS_FLYER: 3,
  SINGULAR: 4,
};
